// extracted by mini-css-extract-plugin
module.exports = {"listBH5":"listB_listBH5__YI0_t"};